import React, {Component} from 'react';
import $ from 'jquery';
import {Link, NavLink} from "react-router-dom";
import LeftPanel from '../../LeftPanel';
import AOS from "aos";
import {authService} from "../../auth";
import Header from "../../Header";
import StaticHeader from "../../StaticHeader";
import AuthModalComponent from "../../LoginExtra/AuthModalComponent";
import SignUpModal from "../../SignUpModal/signUpModal";
import Chat from "../../FaqChat/chat";
import {isMobileDevice, isWebView} from "../../commons/CommonFunctions";
import LeftPanelUnauth from "../../commons/LeftPanelUnauth";
import AppCommonHeader from '../../commons/AppCommonHeader';
class CeoHeader extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loginSuccess: authService.isAuthenticated(),
            signUpRequired:false,
            pathname:''
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if((window.location.pathname === '/message' || window.location.pathname === '/message-user') && isMobileDevice()){
            this.setState({
                pathname:'message'
            })
        }
    }

    componentDidMount() {
        window.$('#header .iCross').hide();
        window.$("#header .iHamburger").on('click', function (event) {
            window.$('.leftpanel').addClass('navactive');
            window.$('.dgcontainer').addClass('navactive');
            window.$('.staticPage').addClass('navactive');
            window.$('#header .iHamburger').hide();            
            window.$('#header .iCross').show();
        });
        $("body, html").on('click', function (event) {
            if (!$(event.target).closest('#header .iHamburger, .read-more-less-btn').length) {
                $('.leftpanel').removeClass('navactive');
                $('.dgcontainer').removeClass('navactive');
                window.$('.staticPage').removeClass('navactive');
                $('.dropdown-menu.show').removeClass('show');
                window.$('#header .iHamburger').show();            
                window.$('#header .iCross').hide();
            }
        });
        window.$('.usermenu .dropdown-submenu > a').on("click", function (e) {
            var submenu = $(this);
            $('.usermenu .dropdown-submenu .dropdown-menu').removeClass('show');
            submenu.next('.usermenu .dropdown-menu').addClass('show');
            e.stopPropagation();
        });

        AOS.init({});
    }

    loginRequired=(slug)=> {
        this.setState({'loginRequired': true, 'pathname':slug})
        window.$('#loginModal').modal('show');
    }

    signUpRequired=()=>{
        this.setState({'signUpRequired':true})
        window.$('#signupModal').modal('show');
    }

    handleSignUpClose = () => {
        this.setState({'signUpRequired': false})
        window.$('#signupModal').modal('hide');
    }

    render() {
        return (
            <div className={"letterfromceodesk staticPage"}>
                 {/* {!isWebView() ?
                    (!this.state.loginSuccess ? <StaticHeader /> : <Header />)
                    :
                    <AppCommonHeader goBackButtn={this.props.goBackButtn} isBackWebPage={true} />
                } */}

                {!this.state.loginSuccess ? <StaticHeader /> : <Header />}

                {this.props.children}

                {!this.state.loginSuccess ?
                    <LeftPanelUnauth signUpRequired={this.signUpRequired}/> :
                <LeftPanel/>}
                {this.state.loginRequired === true ? <AuthModalComponent pathname={this.state.pathname} history={this.props.history}/> : null}
                {this.state.signUpRequired === true ? <SignUpModal  handleSignUpClose={this.handleSignUpClose} history={this.props.history}/> : null}
                {this.state.pathname === 'message' ? <></>:<Chat/>}
            </div>
        );
    }
}

export default CeoHeader;